import PayCenter from '@/views/mobile/PayCenter/index'

// 定义路由路径数列表
export default [{
  path: '/payCenter',
  name: '会员买单',
  component: PayCenter
}]



// WEBPACK FOOTER //
// ./src/views/mobile/PayCenter/routers/index.js